export interface CommissionImage {
  url: string;
  type: string;
}

export const commissionImages: CommissionImage[] = [
  {
    url: "/tae.jpg",
    type: "halfbody",
  },
  {
    url: "/zalorii.jpg",
    type: "halfbody",
  },
  {
    url: "/whitemane.jpg",
    type: "halfbody",
  },
  {
    url: "/quartise.jpg",
    type: "halfbody",
  },
  {
    url: "/tristane.jpg",
    type: "halfbody",
  },
  {
    url: "/rose.jpg",
    type: "bust",
  },
  {
    url: "/kalrissa.jpg",
    type: "bust",
  },
  {
    url: "/saedre.jpg",
    type: "bust",
  },
  {
    url: "/maeve.jpg",
    type: "bust",
  },
  {
    url: "/lillian.jpg",
    type: "sketch",
  },
  {
    url: "/valerial.jpg",
    type: "sketch",
  },
  {
    url: "/amrathor.jpg",
    type: "sketch",
  },
  {
    url: "/ceto.jpg",
    type: "sketch",
  },
  {
    url: "/helyne.jpg",
    type: "sketch",
  },
  {
    url: "/haelissa.jpg",
    type: "hbsketch",
  },
  {
    url: "/athriel.jpg",
    type: "hbsketch",
  },
  {
    url: "/sellene.jpg",
    type: "hbsketch",
  },
  {
    url: "/elyanthe.jpg",
    type: "hbsketch",
  },
  {
    url: "/cloverhoney.jpg",
    type: "fbsketch",
  },
  {
    url: "/draenei.jpg",
    type: "fbsketch",
  },
  {
    url: "/demon.jpg",
    type: "fbsketch",
  },
  {
    url: "/rinh6.jpg",
    type: "fbsketch",
  },
];
